<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="mb-5">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="2" class="mr-5 mb-1">
              Lens: Items List
            </v-col>
            <v-col cols="12" md="2" class="mr-5 mb-1 ">
              <template>
                <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    dense
                    outlined
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="auto">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      depressed
                      color="warning"
                      v-on="on"
                      v-on:click="addLensItem"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add Item</span>
              </v-tooltip>
            </v-col>
            <v-col cols="auto">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      depressed
                      color="primary"
                      v-on="on"
                      v-on:click="printList"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Print List</span>
              </v-tooltip>
            </v-col>

          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
    <div id="print">
      <v-card>
        <v-data-table
            :headers="headers"
            :items="lensProducts"
            :search="search"
            dense
            :loading="loadingstatus"
            loading-text="Loading... Please wait"
            disable-pagination
            hide-default-footer
        >
          <template v-slot:item.status="{ item }">
            <v-chip
                v-if="item.status == 1"
                color="success"
                small
            >
              Active
            </v-chip>
            <v-chip
                v-if="item.status == 0"
                color="warning"
                small
            >
              Inactive
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    @click="editLensData(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    label
                    outlined
                    small
                >
                  <v-icon> mdi-pencil</v-icon>
                </v-chip>
              </template>
              <span>Invoice Edit</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Lens: {{ lensItemsModalTitle }}</v-card-title>
            <v-card-text>
              <v-autocomplete
                  v-model="submitData.vendor_id"
                  :items="vendorList"
                  item-text="name"
                  item-value="id"
                  label="Vendor Name"
              ></v-autocomplete>
              <v-autocomplete
                  v-model="submitData.brand_id"
                  :items="brandList"
                  item-text="name"
                  item-value="id"
                  label="Brand Name/ Manufacturer"
              ></v-autocomplete>
              <v-text-field
                  v-model="submitData.name"
                  label="Name"
              ></v-text-field>
              <v-text-field
                  v-model="submitData.model_name"
                  label="Model Name"
              ></v-text-field>
              <v-select
                  v-model="submitData.lens_type"
                  :items="lensTypes"
                  label="Lens Type"
              ></v-select>
              <v-text-field
                  v-model="submitData.buy_price"
                  label="Buy price"
              ></v-text-field>
              <v-text-field
                  v-model="submitData.sell_price"
                  label="Bill Amount"
              ></v-text-field>

              <v-select
                  v-model="submitData.country"
                  :items="countries"
                  label="Country name"
                  single-line
              ></v-select>

              <v-select
                  v-model="submitData.status"
                  :items="status"
                  label="Status"
                  item-value="key"
                  item-text="value"
              ></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" dark @click="resetSubmitForm"> Cancel</v-btn>
              <v-btn color="primary" @click="dataSubmit"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 7),
      menu2: false,
      loadingstatus: true,
      lensItemsModalTitle: null,
      summary: {},
      submitData: {
        id: null,
        name: null,
        vendor_id: null,
        brand_id: null,
        vendor_name: null,
        brand_name: null,
        model_name: null,
        lens_type: null,
        buy_price: null,
        sell_price: null,
        country: null,
      },
      vendorList: [],
      brandList: [],
      countryList: [],
      paramList: [],
      countries: [
        'United States',
        'Canada',
        'United Kingdom',
        'Germany',
        'France',
        'Japan',
        'India',
        'China',
        'Australia',
        'Brazil',
        'South Africa',
        'Italy',
        'Russia',
        'Mexico',
        'South Korea',
      ],
      lensTypes:[
        'Monofocal',
        'Multifocal',
        'Toric',
        'Aspheric',
        'Trifocal',
        'Hydrophobic',
      ],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
      headers: [
        {
          text: "#",
          value: "sno",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Model Name",
          value: "model_name",
        },
        {
          text: "Vendor Name",
          value: "vendor.name",
        },
        {
          text: "Brand Name",
          value: "brand.name",
        },
        {
          text: "Lens Type",
          value: "lens_type",
        },
        {
          text: "Vendor Price",
          value: "buy_price",
        },
        {
          text: "Bill Amount",
          value: "sell_price",
        },
        {
          text: "Country",
          value: "origin_country",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Action",
          value: "actions",
        },
      ],

      lensProducts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Lens List",
          disabled: true,
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },

  created() {
    this.permissionCheck();
    this.initialize();
    this.getData();
  },
  computed: {},
  methods: {
    permissionCheck() {
      atshq
          .get("users/user-group?id=" + localStorage.getItem("userId"))
          .then((response) => {
            if (!(response.data.data.includes("ot-setup") || response.data.data.includes("admin"))) {
              this.$router.go(-1);
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    resetSubmitForm() {
      this.dialog = false;
      this.lensItemsModalTitle = '';
      this.submitData.id = null;
      this.submitData.vendor_id = null;
      this.submitData.brand_id = null;
      this.submitData.name = null;
      this.submitData.model_name = null;
      this.submitData.lens_type = null;
      this.submitData.buy_price = null;
      this.submitData.sell_price = null;
      this.submitData.country = null;
      this.submitData.status = null;
    },
    addLensItem() {
      this.dialog = true;
      this.lensItemsModalTitle = "Add Lens Item";
    },
    editLensData(item) {
      this.dialog = true;
      this.lensItemsModalTitle = 'Edit Lens Item';
      this.submitData.id = item.id;
      this.submitData.vendor_id = item.vendor_id;
      this.submitData.brand_id = item.brand_id;
      this.submitData.name = item.name;
      this.submitData.model_name = item.model_name;
      this.submitData.lens_type = item.lens_type;
      this.submitData.buy_price = item.buy_price;
      this.submitData.sell_price = item.sell_price;
      this.submitData.country = item.origin_country;
      this.submitData.status = item.status;
    },


    dataSubmit() {
      let submitUrl = this.submitData.id ? "lens/lens/" + this.submitData.id : "lens/lens";
      if (this.submitData.id) {
        atshq
            .put(submitUrl, {
              submitData: this.submitData,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingstatus = false;
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.initialize();
              this.resetSubmitForm();
            })
            .catch((e) => {
              this.$noty.error(e.response.data.message);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      } else {
        atshq
            .post(submitUrl, {
              submitData: this.submitData,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingstatus = false;
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.initialize();
              this.resetSubmitForm();
            })
            .catch((e) => {
              this.$noty.error(e.response.data.message);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      }
    },
    getData() {
      atshq
          .get("lens/lens-preload-data")
          .then((response) => {
            // this.vendorList = response.data.data.vendor;
            // this.brandList = response.data.data.brand;
            this.paramList = response.data.data.param;

            this.loadingstatus = false;
          })
          .catch((e) => {
            console.log(e);
            this.errors.push(e);
          });
    },
    initialize() {
      atshq
          .get("lens/lens")
          .then((response) => {
            this.lensProducts = response.data.lensProducts;
            this.vendorList = response.data.vendors;
            this.brandList = response.data.brands;

            this.loadingstatus = false;
          })
          .catch((e) => {
            console.log(e);
            this.errors.push(e);
          });
    },

    editLensItem(item) {
      this.loadingstatus = true;
      atshq
          .get("lens/lens/" + item.id)
          .then((response) => {
            this.submitData = response.data.data;

            this.dialog = true;
            this.loadingstatus = false;
          })
          .catch((e) => {
            console.log(e);
            this.errors.push(e);
          });
    },

    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );

      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
    dateSelect() {
      this.loadingstatus = true;
      this.initialize();
    },
  },
};
</script>
